import {
    Controller
} from "stimulus"
import retainScroll from '../retainScroll'

export default class extends Controller {
    retainScroll

    get formData()
    {
        return new FormData(this.element)
    }

    get searchParams()
    {
        return new URLSearchParams(this.formData)
    }

    get queryString()
    {
        return this.searchParams.toString()
    }

    connect()
    {
        this.retainScroll = new retainScroll()
    }

    submit()
    {
        if (this.element.method.toUpperCase() === 'GET') {
            new FormData(this.element)
            this.retainScroll.visit(this.element.action + '?' + this.queryString);
        } else {
            this.element.submit()
        }
    }

    disconnect()
    {
        this.retainScroll.tearDown();
        this.retainScroll = null
    }
}
